import { IconButton, useTheme } from '@mui/material';
import React from 'react';


const ButtonIconSvg = ({ isActive,isDisabled, children,onClick , onMouseEnter, onMouseLeave, primaryOnInteract}: { isActive?: boolean; isDisabled?: boolean; onClick?: (e:any) => void,children: React.ReactNode , onMouseEnter?: () => void, onMouseLeave?: () => void, primaryOnInteract?: boolean }) => {
	const theme = useTheme();
	const interactColor = primaryOnInteract || isActive ? theme.palette.primary.main : 'black';


	return (
		<IconButton
			disabled={isDisabled}
			onClick={onClick}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			sx={{
				p:"2px",
				color: isActive && !isDisabled ? theme.palette.primary.main : theme.palette.secondary.main, // Icon color (for MUI icons)
				'&:hover': {
					color: interactColor,
					//backgroundColor: isActive ? 'none' : '#F3F3F3',
				},
				...(primaryOnInteract
					? { '&:active': { color: theme.palette.primary.main } }
					: {}),
			}}
		>
			{children}
		</IconButton>
	);
};

export default ButtonIconSvg;